import { WorldTourTrack } from "model/Match/Set/WorldTour/Track/WorldTourTrack";
import { WorldTourTrackTimes } from "./WorldTourTrackTimes";
import { SetMatchTimesTableContainer } from "./styles";
import { MatchTeams } from "model/Match/MatchTeams";
import { MatchmakingTrack } from "model/Match/Set/Matchmaking/Track/MatchmakingTrack";

interface Props {
  tracks: MatchmakingTrack[] | WorldTourTrack[];
  teams: MatchTeams;
  tournamentId: string;
}

export const WorldTourSetTimes = ({ tracks, teams, tournamentId }: Props) => {
  return (
    <div>
      {tracks.map((track, i) => (
        <SetMatchTimesTableContainer even={i % 2 === 0}>
          <WorldTourTrackTimes
            key={`${i}-${track.trackId ?? ""}`}
            track={track}
            teams={teams}
            trackNum={i + 1}
            tournamentId={tournamentId}
          />
        </SetMatchTimesTableContainer>
      ))}
    </div>
  );
};
